import { Card } from 'components/common';
import {
  DialogFormWrapper,
  FormActionsStyle,
  FormBody,
  FormGroupTitle,
  FormHeader,
  FormRow,
  FormTitle,
} from 'components/common/Forms/Forms.styled';
import { Col } from 'components/common/Grid';
import { FaKey } from 'react-icons/fa';
import { CommonButton } from '../../../../components/common/Forms/Button';
import { CardLoader } from '../../../../components/common/Loading';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { ssoLoginURL } from '../../../../routes/AppRoutes';
import { TrustData, TrustFormValues } from '../../../../types/trusts';
import { useForm } from 'react-hook-form';
import { useCallback } from 'react';
import { CommonInput } from '../../../../components/common/Forms/Input';
import { useMutateUpdateTrust } from '../../../../query/trusts';
import { successToast } from '../../../../utils/toast';
import { SettingsLinkCard } from '../../../staff/settings/links/SettingsLinkCard';

type Props = {
  trust: TrustData;
};

export const TrustSSOPreferences = ({ trust }: Props) => {
  const { t } = useCommonTranslation();
  const { id: trustId } = trust;

  const { mutate: updateTrust, isLoading } = useMutateUpdateTrust({
    onSuccess: () => {
      successToast(t('trust-sso-update-success'));
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<TrustFormValues>({
    defaultValues: {
      ...trust,
    },
  });
  const handleStepSubmit = useCallback(
    async (data: TrustFormValues) => {
      updateTrust({ ...data, sso_provider_type: data.sso_provider_id ? 'saml' : '' });
    },
    [updateTrust],
  );

  return (
    <>
      <Col md={6}>
        <Card>
          <DialogFormWrapper>
            <FormBody
              onSubmit={handleSubmit(handleStepSubmit)}
              autoComplete={'false'}
            >
              <FormHeader>
                <FaKey />
                <FormTitle>{t('sso-saml-title')}</FormTitle>
              </FormHeader>
              <FormGroupTitle style={{ textAlign: 'center' }}>
                {t('sso-saml-description')}
              </FormGroupTitle>
              <FormRow
                style={{
                  marginTop: 'var(--s2)',
                }}
              >
                <CommonInput
                  label={t('sso_provider_id')}
                  placeholder={t('sso_provider_id')}
                  helperText={errors.sso_provider_id?.message}
                  hasError={Boolean(errors.sso_provider_id)}
                  {...register('sso_provider_id')}
                />
              </FormRow>
              <FormActionsStyle align='center'>
                <CommonButton variant='primary' type='submit'>
                  {t('save')}
                </CommonButton>
              </FormActionsStyle>
            </FormBody>
          </DialogFormWrapper>
          {isLoading && <CardLoader fillWrapper={true} />}
        </Card>
      </Col>
      {trust?.sso_provider_id && (
        <Col md={6}>
          <SettingsLinkCard
            path={`${ssoLoginURL}/${trustId}`}
            title={t('sso-link')}
            description={''}
            hideOpenButton
          />
        </Col>
      )}
    </>
  );
};
